/** 产品主品牌名 */
export const BRAND_NAME = '原力引擎';

/** 产品副标题（Logo 区第二行） */
export const BRAND_PRODUCT = '智能办公系统';

/** 浏览器默认标题 */
export const BRAND_PAGE_TITLE = `${BRAND_NAME} · ${BRAND_PRODUCT}`;

/** 管理后台浏览器标题 */
export const BRAND_ADMIN_PAGE_TITLE = `${BRAND_NAME} · 管理控制台`;

/** 客户端页脚备案文案 */
export const BRAND_APP_FOOTER =
  '© 2026 原力引擎 智能办公系统 · ICP经营许可证 京B2-20261501';

/** 登录/注册页脚文案 */
export const BRAND_AUTH_FOOTER = '原力引擎 · 京B2-20261501';

/**
 * 生成带品牌后缀的页面标题
 * @param pageTitle 当前页面名称
 */
export function brandDocumentTitle(pageTitle: string): string {
  return `${pageTitle} · ${BRAND_NAME}`;
}
